// Avatar do contato.
//
// Quase nenhum contato do WhatsApp chega com foto, então as iniciais são o
// caso normal, não o fallback. A cor sai de um hash do identificador: a mesma
// pessoa fica sempre com a mesma cor, o que ajuda a bater o olho e reconhecer a
// conversa na lista sem ler o nome.
//
// A paleta é derivada das cores da marca (oliva e âmbar), em tons terrosos —
// nada de arco-íris aleatório, que brigaria com o resto do sistema.

import React from 'react';
import { iniciais } from '../formato';

const PALETA = [
  'bg-primary/15 text-primary dark:bg-primary/25 dark:text-[#B4C77A]',
  'bg-secondary/20 text-[#9A6A12] dark:bg-secondary/20 dark:text-secondary',
  'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300',
  'bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300',
  'bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300',
  'bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300',
  'bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300',
  'bg-teal-100 text-teal-700 dark:bg-teal-900/40 dark:text-teal-300',
];

function corDe(chave: string): string {
  let h = 0;
  for (let i = 0; i < chave.length; i++) h = (h * 31 + chave.charCodeAt(i)) >>> 0;
  return PALETA[h % PALETA.length];
}

interface Props {
  nome: string | null | undefined;
  telefone: string | null | undefined;
  url?: string | null;
  /** Identificador estável para a cor — o id do contato, não o nome. */
  chave: string;
  tamanho?: 'sm' | 'md' | 'lg';
}

const TAMANHOS = {
  sm: 'w-8 h-8 text-[11px]',
  md: 'w-11 h-11 text-sm',
  lg: 'w-16 h-16 text-lg',
};

export default function Avatar({ nome, telefone, url, chave, tamanho = 'md' }: Props) {
  if (url) {
    return (
      <img
        src={url}
        alt=""
        className={`${TAMANHOS[tamanho]} shrink-0 rounded-full object-cover ring-1 ring-black/5 dark:ring-white/10`}
      />
    );
  }
  return (
    <div
      className={`${TAMANHOS[tamanho]} ${corDe(chave)} flex shrink-0 select-none items-center justify-center rounded-full font-bold tracking-wide ring-1 ring-black/5 dark:ring-white/10`}
      aria-hidden
    >
      {iniciais(nome, telefone)}
    </div>
  );
}
